import { createContext, type PropsWithChildren, use, useContext, useRef } from 'react';

import config from 'config';
import { createExperimentationClient } from 'experimentation-client-js';

type ExperimentationClient = Awaited<ReturnType<typeof createExperimentationClient>> | null;

const ExperimentationContext = createContext<ExperimentationClient>(null);

export function useExperimentationClient(): ExperimentationClient {
    return useContext(ExperimentationContext);
}

const createEventWriter = () => {
    return {
        streamName: 'wellfunnel-builder-feature-flag-events',
        eventSourceName: 'wellfunnel-builder-front',
        sendRecord(record: object): Promise<boolean> {
            console.log('Event to send:', record);
            return Promise.resolve(true);
        },
    };
};

async function initializeClient(): Promise<ExperimentationClient> {
    if (!config.EPPO_SDK_KEY) {
        return Promise.resolve(null);
    }

    try {
        return await createExperimentationClient({
            apiKey: config.EPPO_SDK_KEY,
            stage: config.ENV,
            projectName: 'wellfunnel-builder-front',
            projectNamespace: 'wn',
            eventWriter: createEventWriter(),
        });
    } catch (error: unknown) {
        console.error('Failed to initialize Eppo:', error);
        return null;
    }
}

export function ExperimentationProvider({ children }: PropsWithChildren) {
    const clientPromiseRef = useRef<Promise<ExperimentationClient> | null>(null);

    clientPromiseRef.current ??= initializeClient();

    const client = use(clientPromiseRef.current);

    return <ExperimentationContext.Provider value={client}>{children}</ExperimentationContext.Provider>;
}
